module.exports = __webpack_public_path__ + "static/img/opportunity-head.c2094a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/activity/opportunity-head.png
// module id = nXWx
// module chunks = 86